import { Link } from 'react-router-dom';
import { Separator } from '../ui/separator';

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-[hsl(var(--border))] bg-white">
      <div className="mx-auto max-w-[var(--grid-max)] px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/logo.png"
                alt="Smile Score Solutions"
                className="h-9 w-auto"
              />
            </Link>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
              Recover declined patients. Recover lost revenue.
            </p>
          </div>

          {/* Nav Links */}
          <div>
            <h4 className="text-sm font-semibold text-[hsl(var(--sss-navy))] mb-3">Platform</h4>
            <ul className="space-y-2">
              <li><Link to="/how-it-works" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">How It Works</Link></li>
              <li><Link to="/pricing" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">Pricing</Link></li>
              <li><a href="https://approvemysmile.com/register/personal" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">Get Started</a></li>
              <li><a href="https://approvemysmile.com/" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">Login</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-[hsl(var(--sss-navy))] mb-3">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">Contact</Link></li>
              <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">Book a Demo</Link></li>
            </ul>
          </div>

          {/* Legal & Address */}
          <div>
            <h4 className="text-sm font-semibold text-[hsl(var(--sss-navy))] mb-3">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">Terms & Conditions</Link></li>
            </ul>
            <p className="mt-4 text-sm text-muted-foreground" data-testid="footer-address">
              1234 West Chester Pike Ste. 300<br />
              West Chester, PA 19382
            </p>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; 2025 Smile Score Solutions. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/contact" className="text-xs text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">
              Contact Us
            </Link>
            <a href="https://approvemysmile.com/" target="_blank" rel="noopener noreferrer" className="text-xs text-muted-foreground hover:text-[hsl(var(--sss-navy))] transition-colors">
              Login
            </a>
          </div>
        </div>

        {/* Results Disclaimer */}
        <div className="mt-8 pt-6 border-t border-[hsl(var(--border))]">
          <p className="text-[10px] sm:text-xs text-muted-foreground leading-relaxed max-w-4xl">
            Smile Score Solutions provides educational content and financial wellness tools. We are not a credit repair organization for purposes of our free educational platform. Optional paid services that include credit dispute assistance are subject to separate agreements and disclosures, including the Consumer Credit File Rights Under State and Federal Law disclosure required by federal law. Patients have the right to dispute inaccurate information on their credit reports directly with credit bureaus at no cost. No specific score outcome is promised or guaranteed.
          </p>
        </div>
      </div>
    </footer>
  );
};
